import React, { useState } from 'react'

// mui
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import SettingsIcon from '@mui/icons-material/Settings';
import { Typography, IconButton } from '@mui/material';

import ManageCampaignDialog from './../../../components/dialogs/fundraising/ManageCampaignDialog'

import { useAppSelector } from '../../../hooks'

import Ambassadors from './Ambassadors'
import CampaignPage from './CampaignPage';
import DiscoveryCalls from './DiscoveryCalls';
import Notifications from './Notifications'

export default function Manage(props: any) {

    const [selectedPage, setSelectedPage] = useState<string | null>('campaign-page')

    const [showManageCampaignDialog, setShowManageCampaignDialog] = useState<boolean>(false)

    const selectedFundraisingCampaign = useAppSelector(state => state.fundraising.selectedCampaign)
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    return (
        <div className="container-fluid p-0">
            <div className="col-12 mt-5">
                <div className="row px-4">
                    <div className="col-12 col-lg-4 d-flex flex-row justify-content-start align-items-center">
                        <Typography variant="h2">{selectedFundraisingCampaign ? selectedFundraisingCampaign.campaignName : ''}</Typography>
                        <IconButton className="mx-2"
                            onClick={() => {
                                setShowManageCampaignDialog(true)
                            }}
                        >
                            <SettingsIcon />
                        </IconButton>
                    </div>
                    <div className="col-12 col-lg-8">
                        <ToggleButtonGroup
                            color="primary"
                            value={selectedPage}
                            exclusive
                            onChange={(e, value) => { setSelectedPage(value) }}
                            className="w-100"
                        >
                            <ToggleButton className="w-50" value="campaign-page">Campaign Page</ToggleButton>
                            <ToggleButton className="w-50" value="ambassadors">{selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverridePlural : 'Ambassadors'}</ToggleButton>
                            <ToggleButton className="w-50" value="discovery-calls">Discovery Calls</ToggleButton>
                            <ToggleButton className="w-50" value="notifications">Notifications</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                </div>
            </div>
            <div className="row my-5 p-0">
                {
                    selectedPage == 'campaign-page' &&
                    <CampaignPage />
                }

                {
                    selectedPage == 'ambassadors' &&
                    <Ambassadors />
                }

                {
                    selectedPage == 'discovery-calls' &&
                    <DiscoveryCalls />
                }

                {
                    selectedPage == 'notifications' &&
                    <Notifications />
                }

            </div>

            <ManageCampaignDialog visible={showManageCampaignDialog} onClose={() => setShowManageCampaignDialog(false)} />
        </div>
    )
}